import { UPLOAD_LEGAL_DOCUMENT_API_URL } from '../../../../constants/ApiUrlConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import { call, put, takeEvery } from 'redux-saga/effects';
import toast from 'react-hot-toast';
import { uploadLegalDocumentFailure, uploadLegalDocumentSuccess } from '../actions/settingsActions';
import { UPLOAD_LEGAL_DOCUMENT_REQUEST } from '../../../../constants/ActionNameConstants';

function* uploadLegalDocumentSaga(action) {
  try {
    const { file, audioFileId } = action.payload;

    const formData = new FormData();
    formData.append('file', file, file.name);

    const response = yield call(
      postApiRequest,
      `${UPLOAD_LEGAL_DOCUMENT_API_URL}?AudioFileId=${audioFileId}`,
      formData,
    );

    if (response.data.success) {
      toast.success('File uploaded successfully');
      yield put(uploadLegalDocumentSuccess(response?.data));
    } else {
      toast.error('File upload failed');
      yield put(uploadLegalDocumentFailure(response?.data));
    }
  } catch (error) {
    yield put(uploadLegalDocumentFailure(error.message));
    toast.error('File upload failed');
  }
}

export function* watchUploadLegalDocument() {
  yield takeEvery(UPLOAD_LEGAL_DOCUMENT_REQUEST, uploadLegalDocumentSaga);
}
